/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrp } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrp';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrpFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrpFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrpToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrp';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrp } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrp';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrpFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrpFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrpToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrp';
import type { ExecRiskFiler } from './ExecRiskFiler';
import {
    ExecRiskFilerFromJSON,
    ExecRiskFilerFromJSONTyped,
    ExecRiskFilerToJSON,
} from './ExecRiskFiler';

/**
 * 
 * @export
 * @interface ExecRiskReturnHeader
 */
export interface ExecRiskReturnHeader {
    /**
     * 
     * @type {ExecRiskFiler}
     * @memberof ExecRiskReturnHeader
     */
    Filer?: ExecRiskFiler;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReturnHeader
     */
    TaxYr?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReturnHeader
     */
    BuildTS?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReturnHeader
     */
    ReturnTs?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReturnHeader
     */
    ReturnTypeCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReturnHeader
     */
    TaxPeriodEndDt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReturnHeader
     */
    TaxPeriodBeginDt?: string;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrp}
     * @memberof ExecRiskReturnHeader
     */
    PreparerPersonGrp?: ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrp;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrp}
     * @memberof ExecRiskReturnHeader
     */
    BusinessOfficerGrp?: ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrp;
}

/**
 * Check if a given object implements the ExecRiskReturnHeader interface.
 */
export function instanceOfExecRiskReturnHeader(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskReturnHeaderFromJSON(json: any): ExecRiskReturnHeader {
    return ExecRiskReturnHeaderFromJSONTyped(json, false);
}

export function ExecRiskReturnHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskReturnHeader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'Filer': !exists(json, 'Filer') ? undefined : ExecRiskFilerFromJSON(json['Filer']),
        'TaxYr': !exists(json, 'TaxYr') ? undefined : json['TaxYr'],
        'BuildTS': !exists(json, 'BuildTS') ? undefined : json['BuildTS'],
        'ReturnTs': !exists(json, 'ReturnTs') ? undefined : json['ReturnTs'],
        'ReturnTypeCd': !exists(json, 'ReturnTypeCd') ? undefined : json['ReturnTypeCd'],
        'TaxPeriodEndDt': !exists(json, 'TaxPeriodEndDt') ? undefined : json['TaxPeriodEndDt'],
        'TaxPeriodBeginDt': !exists(json, 'TaxPeriodBeginDt') ? undefined : json['TaxPeriodBeginDt'],
        'PreparerPersonGrp': !exists(json, 'PreparerPersonGrp') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrpFromJSON(json['PreparerPersonGrp']),
        'BusinessOfficerGrp': !exists(json, 'BusinessOfficerGrp') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrpFromJSON(json['BusinessOfficerGrp']),
    };
}

export function ExecRiskReturnHeaderToJSON(value?: ExecRiskReturnHeader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Filer': ExecRiskFilerToJSON(value.Filer),
        'TaxYr': value.TaxYr,
        'BuildTS': value.BuildTS,
        'ReturnTs': value.ReturnTs,
        'ReturnTypeCd': value.ReturnTypeCd,
        'TaxPeriodEndDt': value.TaxPeriodEndDt,
        'TaxPeriodBeginDt': value.TaxPeriodBeginDt,
        'PreparerPersonGrp': ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderPreparerPersonGrpToJSON(value.PreparerPersonGrp),
        'BusinessOfficerGrp': ExecRiskApiAppApiV1EagerTasksForm990ModelsBaseFilingHeaderBusinessOfficerGrpToJSON(value.BusinessOfficerGrp),
    };
}

